"use client";
import { Post } from "@/axios/AxiosFunctions";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/Core/Button";
import { Input } from "@/components/Core/Input";
import { BaseURL } from "@/config/apiUrl";
import {
  apiHeader,
  RenderToast,
  validateEmail,
  validateNestedParams,
} from "@/helper/HelperFunction";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "./Login.module.css";
import ThemeSwitcher from "@/components/ThemeSwitcher";
import { saveLoginUserData } from "@/store/auth/authSlice";

const LOADING = {
  LOGIN: "loginLoader",
  RESEND: "resendLoader",
  CMS: "cmsLoader",
};

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle Login
  const handleLogin = async () => {
    const url = BaseURL("auth/admin/login");
    const params = {
      email,
      password,
    };
    if (!validateNestedParams(params)) return;
    if (!validateEmail(params.email)) {
      return RenderToast({
        type: "error",
        message: "Please enter a valid email!",
      });
    }
    setLoading(LOADING.LOGIN);
    const response = await Post(url, params, apiHeader());
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "Login successful!",
      });
      dispatch(saveLoginUserData(response.data));
      navigate("/");
    }
    setLoading(false);
  };

  return (
    <AuthLayout>
      <div className={classes.loginContainer}>
        <div className={classes.themeSwitcherContainer}>
          <ThemeSwitcher />
        </div>
        <div className={classes.formContainer}>
          <div className={classes.loginHeadingContainer}>
            <h6 className={classes.loginHeading}>Welcome Again</h6>
            <p>Enter your credentials to Log In.</p>
          </div>
          <div className={classes.loginForm}>
            <Input
              placeholder="name@example.com"
              type="email"
              value={email}
              setter={setEmail}
              label={"Email Address"}
            />
            <Input
              placeholder="Enter Password"
              value={password}
              setter={setPassword}
              type="password"
              label={"Password"}
              labelStyle={{ display: "flex", alignItems: "center" }}
              label2={
                <span
                  className={classes.forgotPassword}
                  onClick={() => navigate("/forget-password")}
                >
                  Forgot Password?
                </span>
              }
              onEnter={handleLogin}
            />
          </div>
          <Button
            className={classes.loginBtn}
            label={loading === LOADING.LOGIN ? "Please Wait..." : "Login"}
            disabled={loading === LOADING.LOGIN}
            onClick={handleLogin}
            type="square"
          />
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
